/* eslint-disable */
require('./apple')
require('./beer_bottles')
require('./beer')
require('./burger_and_cola')
require('./chicken_legs')
require('./coffee')
require('./cubata')
require('./cup')
require('./cupcake_in_hand')
require('./desserts')
require('./discount_coupon')
require('./euro_symbol')
require('./french_fries')
require('./hamburger')
require('./home')
require('./ice_cream_with_chopsticks')
require('./juice')
require('./new_hot_dog')
require('./noodles')
require('./paella')
require('./patties')
require('./piece_of_pizza')
require('./pineapple_cocktail')
require('./pizza_in_a_box')
require('./profile')
require('./qr')
require('./recharge')
require('./refund')
require('./sandwich')
require('./shirt')
require('./snaks')
require('./sushi')
require('./taco')
require('./tag')
require('./tokens')
require('./transactions')
require('./water')
require('./wine_bottle')
